import { useCallback } from 'react'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { useSWRConfig } from 'swr'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import { useCoursePathKey } from '../hooks/use-course-data'
import type { CourseDataInterface } from '../types/course-interface'
import { TrackingApi } from './session-logging-api'

export const useUpdateQuizTrackingSession = (): UseMutationResult<void, Error, number> => {
  const { mutate } = useSWRConfig()
  const courseDataKey = useCoursePathKey()

  const lockedResponseHandler = useCallback(
    () =>
      mutate(
        courseDataKey,
        (data?: CourseDataInterface) => (data ? { ...data, lectureSessionLogging: false } : data),
        { revalidate: true },
      ),
    [courseDataKey, mutate],
  )

  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.post>({
    method: RequestMethodsEnum.post,
    lockedResponseHandler,
  })

  return useMutation({
    mutationFn: (sessionId: number) => fetcher(`${TrackingApi.UpdateQuiz}/${sessionId}`),
    retry: false,
  })
}
